import { render, staticRenderFns } from "./SpecialCouponBtn.vue?vue&type=template&id=3a7e34e4&scoped=true"
import script from "./SpecialCouponBtn.vue?vue&type=script&lang=js"
export * from "./SpecialCouponBtn.vue?vue&type=script&lang=js"
import style0 from "./SpecialCouponBtn.vue?vue&type=style&index=0&id=3a7e34e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7e34e4",
  null
  
)

export default component.exports